import {
  ACTIVE_TAB_DOC_VIEW,
  ACTIVE_TAB_RECO,
  ACTIVE_TAB_VIEW_RECO,
  AVAILED_FILTER,
  BASE_DATA_FILTER,
  DATE_RANGE,
  DATE_RANGE_FILTER,
  DOC_DATE_TABLE_DATA,
  DOC_VIEW_TABLE_DATA,
  INUM_FILTER,
  ISSUE_WISE_TABLE_DATA,
  LOADER_STATUS,
  MONTH_3B_FILTER,
  MONTH_FILTER,
  PAGE_NO_RECO_HISTORY,
  R_GSTIN_TAXPAYER_FILTER,
  RECO_HISTORY_TABLE_DATA,
  RECO_SELECTION,
  S_GSTIN_TAXPAYER_FILTER,
  SEARCH_STR_RECO,
  SELECTED_MATCHED,
  SELECTED_MISMATCH,
  SELECTED_NOTINGSTN,
  SELECTED_NOTINPR,
  SELECTED_PROBABLE,
  SELECTED_REJECTED,
  SELECTED_YEAR,
  SELECTION,
  SUPPLIER_WISE_TABLE_DATA,
  TOTAL_PAGES_RECO_HISTORY,
  VIEW_RECO_TABLE_DATA,
  TOTAL_PAGES_REJECTED,
  TOTAL_PAGES_NOT_IN_GSTN,
  TOTAL_PAGES_NOT_IN_PR,
  TOTAL_PAGES_MISMATCH,
  TOTAL_PAGES_PROBABLE,
  TOTAL_PAGES_MATCHED,
  PAGE_NO_REJECTED,
  PAGE_NO_NOT_IN_GSTN,
  PAGE_NO_NOT_IN_PR,
  PAGE_NO_MISMATCH,
  PAGE_NO_MATCHED,
  PAGE_NO_PROBABLE,
  SELECTED_ROW_PROBABLE,
  SELECTED_ROW_MISMATCH,
  DOWNLOAD_REPORT_TABLE_DATA,
  UPLOAD_REPORT_TABLE_DATA,
  PAGE_NO_UPLOAD_REPORT,
  TOTAL_PAGES_UPLOAD_REPORT,
  VENDOR_LIST,
  SELECTED_ROW_NOT_IN_GSTN,
  SELECTED_ROW_NOT_IN_PR,
  SELECTED_ROW_MATCHED,
  SELECTED_ROW_REJECTED,
} from "./constants";
import { getLocalStorage } from "components/Helper/Helper.js";
import { Config } from "../../../Config.js";
import axios from "axios";
import { errorToastMessage, successToastMessage } from "utils/errorToast";
import { GSTR2A2BNEW_MSGS } from "Constant/Messages";
import { extractMonthsInRange } from "utils/extractMonths";
import {
  addUniqueKeysDocView,
  addUniqueKeysSupplierWise,
} from "../Utility/utility";
import moment from "moment";

const getRetPeriodFromFY = (selectedYear) => {
  if (!selectedYear) return [];
  const startFullYear = parseInt(selectedYear.split("-")[0], 10);
  const endFullYear = startFullYear + 1;
  const startDate = new Date(startFullYear, 3, 1); // April 1st
  const endDate = new Date(endFullYear, 2, 31);   // March 31st
  return extractMonthsInRange(startDate, endDate);
};

// For all APIs except /generateRecoReport:
//   - Select Report Month → ret_period from dateRange
//   - Document Date      → ret_period from full FY year
const getRetPeriodFromDateRange = (selection, dateRange, selectedYear) => {
  // Report month and document date range are separate filters.
  // Only use month/range when it explicitly comes from report-month picker.
  const isReportMonthFilter = dateRange?.[0]?.key === "reportMonth";
  if (!isReportMonthFilter) {
    return getRetPeriodFromFY(selectedYear);
  }

  const startDate = dateRange?.[0]?.startDate
    ? new Date(dateRange[0].startDate)
    : null;
  const endDate = dateRange?.[0]?.endDate
    ? new Date(dateRange[0].endDate)
    : startDate;

  if (!startDate || isNaN(startDate) || !endDate || isNaN(endDate)) {
    return getRetPeriodFromFY(selectedYear);
  }

  return extractMonthsInRange(startDate, endDate);
};

export function loader(status) {
  return {
    type: LOADER_STATUS,
    loaderStatus: status,
  };
}

export function setActiveTabReco(activeTabReco) {
  return {
    type: ACTIVE_TAB_RECO,
    payload: activeTabReco,
  };
}
export function setActiveTabViewReco(activeTabViewReco) {
  return {
    type: ACTIVE_TAB_VIEW_RECO,
    payload: activeTabViewReco,
  };
}
export function setActiveTabDocView(activeTabDocView) {
  return {
    type: ACTIVE_TAB_DOC_VIEW,
    payload: activeTabDocView,
  };
}
export function setRecoHistoryTableData(recoHistoryTableData) {
  return {
    type: RECO_HISTORY_TABLE_DATA,
    payload: recoHistoryTableData,
  };
}
export function setViewRecoTableData(viewRecoTableData) {
  return {
    type: VIEW_RECO_TABLE_DATA,
    payload: viewRecoTableData,
  };
}

export function setIssueWiseTableData(issueWiseTableData) {
  return {
    type: ISSUE_WISE_TABLE_DATA,
    payload: issueWiseTableData,
  };
}

export function setDocViewTableData(docViewTableData) {
  return {
    type: DOC_VIEW_TABLE_DATA,
    payload: docViewTableData,
  };
}

export function setSupplierWiseTableData(supplierWiseTableData) {
  return {
    type: SUPPLIER_WISE_TABLE_DATA,
    payload: supplierWiseTableData,
  };
}

export function setDownloadReportTableData(downloadReportTableData) {
  return {
    type: DOWNLOAD_REPORT_TABLE_DATA,
    payload: downloadReportTableData,
  };
}

export function setUploadReportTableData(uploadReportTableData) {
  return {
    type: UPLOAD_REPORT_TABLE_DATA,
    payload: uploadReportTableData,
  };
}

export function setDocDateTableData(docDateTableData) {
  return {
    type: DOC_DATE_TABLE_DATA,
    payload: docDateTableData,
  };
}
export function setSearchStr(searchStr) {
  return {
    type: SEARCH_STR_RECO,
    payload: searchStr,
  };
}
export function setSelectedMatched(selectedMatched) {
  return {
    type: SELECTED_MATCHED,
    payload: selectedMatched,
  };
}
export function setSelectedProbable(selectedProbable) {
  return {
    type: SELECTED_PROBABLE,
    payload: selectedProbable,
  };
}
export function setSelectedMismatch(selectedMismatch) {
  return {
    type: SELECTED_MISMATCH,
    payload: selectedMismatch,
  };
}
export function setSelectedNotInPR(selectedNotInPR) {
  return {
    type: SELECTED_NOTINPR,
    payload: selectedNotInPR,
  };
}
export function setSelectedNotInGstn(selectedNotInGstn) {
  return {
    type: SELECTED_NOTINGSTN,
    payload: selectedNotInGstn,
  };
}
export function setSelectedRejected(selectedRejected) {
  return {
    type: SELECTED_REJECTED,
    payload: selectedRejected,
  };
}
export function setRgstinTaxpayerFilter(rgstinTaxpayerFilter) {
  return {
    type: R_GSTIN_TAXPAYER_FILTER,
    payload: rgstinTaxpayerFilter,
  };
}

export function setSgstinTaxpayerFilter(sgstinTaxpayerFilter) {
  return {
    type: S_GSTIN_TAXPAYER_FILTER,
    payload: sgstinTaxpayerFilter,
  };
}

export function setInumFilter(inumFilter) {
  return {
    type: INUM_FILTER,
    payload: inumFilter,
  };
}

export function setMonthFilter(monthFilter) {
  return {
    type: MONTH_FILTER,
    payload: monthFilter,
  };
}

export function setMonth3bFilter(month3bFilter) {
  return {
    type: MONTH_3B_FILTER,
    payload: month3bFilter,
  };
}

export function setBaseDataFilter(baseDataFilter) {
  return {
    type: BASE_DATA_FILTER,
    payload: baseDataFilter,
  };
}

export function setAvailedFilter(availedFilter) {
  return {
    type: AVAILED_FILTER,
    payload: availedFilter,
  };
}

export function setDateRange(dateRange) {
  return {
    type: DATE_RANGE,
    payload: dateRange,
  };
}

export function setDateRangeFilter(dateRangeFilter) {
  return {
    type: DATE_RANGE_FILTER,
    payload: dateRangeFilter,
  };
}

export function setTotalPagesRecoHistory(totalPagesRecoHistory) {
  return {
    type: TOTAL_PAGES_RECO_HISTORY,
    payload: totalPagesRecoHistory,
  };
}

export function setPageNoRecoHistory(pageNoRecoHistory) {
  return {
    type: PAGE_NO_RECO_HISTORY,
    payload: pageNoRecoHistory,
  };
}

export function setSelection(selection) {
  return {
    type: SELECTION,
    payload: selection,
  };
}
export function setRecoSelection(recoSelection) {
  return {
    type: RECO_SELECTION,
    payload: recoSelection,
  };
}
export function setSelectedYear(selectedYear) {
  return {
    type: SELECTED_YEAR,
    payload: selectedYear,
  };
}
export function setTotalPageMatched(totalPageMatched) {
  return {
    type: TOTAL_PAGES_MATCHED,
    totalPageMatched: totalPageMatched,
  };
}
export function setTotalPageMismatch(totalPageMismatch) {
  return {
    type: TOTAL_PAGES_MISMATCH,
    totalPageMismatch: totalPageMismatch,
  };
}
export function setTotalPageProbable(totalPageProbable) {
  return {
    type: TOTAL_PAGES_PROBABLE,
    totalPageProbable: totalPageProbable,
  };
}
export function setTotalPageNotInGstn(totalPageNotInGstn) {
  return {
    type: TOTAL_PAGES_NOT_IN_GSTN,
    totalPageNotInGstn: totalPageNotInGstn,
  };
}
export function setTotalPageNotInPr(totalPageNotInPr) {
  return {
    type: TOTAL_PAGES_NOT_IN_PR,
    totalPageNotInPr: totalPageNotInPr,
  };
}
export function setTotalPageRejected(totalPageRejected) {
  return {
    type: TOTAL_PAGES_REJECTED,
    totalPageRejected: totalPageRejected,
  };
}
export function setPageNoMatched(pageNoMatched) {
  return {
    type: PAGE_NO_MATCHED,
    pageNoMatched: pageNoMatched,
  };
}
export function setPageNoMismatch(pageNoMismatch) {
  return {
    type: PAGE_NO_MISMATCH,
    pageNoMismatch: pageNoMismatch,
  };
}
export function setPageNoProbable(pageNoProbable) {
  return {
    type: PAGE_NO_PROBABLE,
    pageNoProbable: pageNoProbable,
  };
}
export function setPageNoNotInGstn(pageNoNotInGstn) {
  return {
    type: PAGE_NO_NOT_IN_GSTN,
    pageNoNotInGstn: pageNoNotInGstn,
  };
}
export function setPageNoNotInPr(pageNoNotInPr) {
  return {
    type: PAGE_NO_NOT_IN_PR,
    pageNoNotInPr: pageNoNotInPr,
  };
}
export function setPageNoRejected(pageNoRejected) {
  return {
    type: PAGE_NO_REJECTED,
    pageNoRejected: pageNoRejected,
  };
}
export function setSelectedRowProbable(selectedRowProbable) {
  return {
    type: SELECTED_ROW_PROBABLE,
    selectedRowProbable: selectedRowProbable,
  };
}
export function setSelectedRowMismatch(selectedRowMismatch) {
  return {
    type: SELECTED_ROW_MISMATCH,
    selectedRowMismatch: selectedRowMismatch,
  };
}

export function setSelectedRowNotInGstn(selectedRowNotInGstn) {
  return {
    type: SELECTED_ROW_NOT_IN_GSTN,
    selectedRowNotInGstn: selectedRowNotInGstn,
  };
}

export function setSelectedRowNotInPr(selectedRowNotInPR) {
  return {
    type: SELECTED_ROW_NOT_IN_PR,
    selectedRowNotInPR: selectedRowNotInPR,
  };
}

export function setSelectedRowMatched(selectedRowMatched) {
  return {
    type: SELECTED_ROW_MATCHED,
    selectedRowMatched: selectedRowMatched,
  };
}

export function setSelectedRowRejected(selectedRowRejected) {
  return {
    type: SELECTED_ROW_REJECTED,
    selectedRowRejected: selectedRowRejected,
  };
}

export function setPageNoUploadReport(pageNoUploadReport) {
  return {
    type: PAGE_NO_UPLOAD_REPORT,
    pageNoUploadReport: pageNoUploadReport,
  };
}
export function setTotalPagesUploadReport(totalPagesUploadReport) {
  return {
    type: TOTAL_PAGES_UPLOAD_REPORT,
    totalPagesUploadReport: totalPagesUploadReport,
  };
}

export function saveVendorListData(data) {
  return {
    type: VENDOR_LIST,
    vendorList: data,
  };
}

export const getVendorListData = (data) => {
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/getVendorMasterEmailList`,
        // data: {gstin: '07AAAFW4298E1Z0,19AACCC2210P1ZO,07ALNPP7541B1Z0,29ACJPC5330J1ZM,07AABPV9622L1Z6'},
        data: { gstin: data },
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          console.log("response ", response.data.data);
          let modifiedData = response?.data?.data?.map((item) => {
            return {
              ...item,
              listKey: `${item.gstin}~${item.email}`,
            };
          });
          dispatch(saveVendorListData(modifiedData));
          dispatch(loader(false));
          resolve(modifiedData);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};

export const sendEmailToVendors = (data) => {
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/sendEmailReconciliationReport`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          console.log("response ", response);
          dispatch(loader(false));
          resolve(response);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};

export function getGenerateReport(
  selectedGstin,
  selection,
  recoSelection,
  selectedYear,
  taxRate,
  taxableValue,
  dateRange,
  runReco,
  runFuzzy,
  includeITC,
  search,
          activeTabReco,
          activeTabViewReco,
          activeTabDocView,
          entityLabel
) {
  return (dispatch) => {
    const data = {
      gstin: selectedGstin,
      reco_type: recoSelection,
      fyYear: selectedYear,
      recoBase: selection,
      tolLimit: { taxRate, taxableValue },
      dateRange: dateRange,
      ret_period: getRetPeriodFromFY(selectedYear),
      p_across_fy: runReco,
      p_fuzzy_logic: runFuzzy,
      nonAvailedITC: includeITC,
      entity: entityLabel,
    };
    console.log("Data in generate report::", data);
    const url =
      activeTabReco === "1"
        ? `${Config.url}gstR2a2bnew/generateRecoReport`
        : activeTabReco === "2"
        ? `${Config.url}gstR2a2bnew/getViewReco`
        : `${Config.url}gstR2a2bnew/getDocDate`;
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: url,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error === 0) {
            successToastMessage(response.data.message);
            if (activeTabReco === "1") {
              setRecoHistoryTableData(response.data.data);
            } else if (activeTabReco === "2") {
              setViewRecoTableData(response.data.data);
            } else if (activeTabReco === "3") {
              setDocDateTableData(response.data.data);
            }
            resolve(response.data.data);
          } else {
            errorToastMessage(response.data.message);
            if (activeTabReco === "1") {
              setRecoHistoryTableData([]);
            } else if (activeTabReco === "2") {
              setViewRecoTableData([]);
            } else if (activeTabReco === "3") {
              setDocDateTableData([]);
            }
            resolve([]);
          }
          dispatch(loader(false));
        })
        .catch((error) => {
          console.error(error);
          dispatch(loader(false));
          reject(error);
        });
    });
  };
}
export const downloadRecoHistoryExcel = (search) => async (dispatch) => {
  dispatch(loader(true));
  const data = {
    str: search,
  };
  try {
    const response = await axios({
      method: "post",
      url: `${Config.url}gstR2a2bnew/downloadRecoScreenHistoryData`,
      headers: { token: getLocalStorage("loginDetails") },
      responseType: "blob",
      data: data,
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "GSTR2a2b_RECO_HISTORY.xlsx");
    document.body.appendChild(link);
    link.click();

    link.remove();
    URL.revokeObjectURL(url);

    successToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_SUCCESS);
  } catch (error) {
    errorToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_ERROR);
  } finally {
    dispatch(loader(false));
  }
};

export const downloadRecoHistoryIndividualExcel = (row) => async (dispatch, getState) => {
  dispatch(loader(true));
  console.log('row in downloadRecoHistoryIndividualExcel::',row)

  const recoState = getState()?.gstr2a2bNewRecoReducer || {};
  const selectedRecoBase = recoState.selection;
  const selectedDateRange = recoState.dateRange;
  const isSelectedPeriod = selectedDateRange?.[0]?.key === "reportMonth";
  const selectedYearState =
    recoState.selectedYear || row.GSTR_2A_2B_FISCAL_YEAR || row.PR_FISCAL_YEAR || "";
  const selectedRetPeriods = getRetPeriodFromDateRange(
    selectedRecoBase,
    selectedDateRange,
    selectedYearState
  );

  const retPeriodForDownload =
    selectedRetPeriods?.length > 0
      ? selectedRetPeriods.join(",")
      : getRetPeriodFromFY(selectedYearState).join(",");

  const data = {
    isHistory: true,
    batchid: row.UUID ?? "",
    gstin: row.GSTIN ?? "",
    ret_period: retPeriodForDownload,
    isSelectedPeriod,
    reco_type: row.RECO_TYPE ?? "",
    entity_name: row.ENTITY_NAME ?? "",
    fy: row.GSTR_2A_2B_FISCAL_YEAR || row.PR_FISCAL_YEAR || "",
    ra_fy: row.P_ACROSS_FY && row.P_ACROSS_FY == "Y" ? "Yes" : "No",
    tolerance: row.IGNOREIVAL ?? "",
    tolerance_taxes: row.IGNOREIVALTVAL ?? '',
    fuzzy_logic: row.FUZZY_LOGIC && row.FUZZY_LOGIC == "Y" ? "Yes" : "No",
    incld_unavail_crdt:
      row.NONAVAILEDITC && row.NONAVAILEDITC == "Y" ? "Yes" : "No",
  };
  console.log("data in downloadRecoHistoryIndividualExcel", data);
  try {
    const response = await axios({
      method: "post",
      url: `${Config.url}gstR2a2bnew/downloadRecoHistorySingle`,
      headers: { token: getLocalStorage("loginDetails") },
      responseType: "blob",
      data: data,
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${row.UUID}_GSTR2A2B_Reco.xlsx`);
    document.body.appendChild(link);
    link.click();

    link.remove();
    URL.revokeObjectURL(url);

    successToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_SUCCESS);
  } catch (error) {
    errorToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_ERROR);
  } finally {
    dispatch(loader(false));
  }
};
export const downloadRecoReportExcel =
  (docDateTableData) => async (dispatch) => {
    dispatch(loader(true));
    const data = {
      tableData: docDateTableData,
    };
    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/downloadDateWiseRecoReport`,
        headers: { token: getLocalStorage("loginDetails") },
        responseType: "blob",
        data: data,
        validateStatus: () => true, // allow handling all status codes manually
      });

      if (response.status === 200 && response.data) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "GSTR2a2b_Reco_Report.xlsx");
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);

        successToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_SUCCESS);
      } else {
        errorToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_ERROR);
      }
    } catch (error) {
      errorToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_ERROR);
    } finally {
      dispatch(loader(false));
    }
  };
export const downloadExcelDownloadReport = (tableData) => async (dispatch) => {
  dispatch(loader(true));
  const data = {
    tableData,
  };
  const URL = `${Config.url}gstR2a2bnew/downloadScreenTab`;

  try {
    const response = await axios({
      method: "post",
      url: URL,
      headers: { token: getLocalStorage("loginDetails") },
      responseType: "blob",
      data: data,
      validateStatus: () => true, // allow handling all status codes manually
    });

    if (response.status === 200 && response.data) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "GSTR2a2b_DOWNLOAD_REPORT.xlsx");
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      successToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_SUCCESS);
    } else {
      errorToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_ERROR);
    }
  } catch (error) {
    console.log("Error in downloadExcelDownloadReport::", error);
    errorToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_ERROR);
  } finally {
    dispatch(loader(false));
  }
};
export function regenerateDownloadReport(row) {
  return (dispatch) => {
    const data = {
      data: row,
    };
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/regenerateDownloadReport`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error === 0) {
            successToastMessage(response.data.message);
            resolve(response.data.data);
          } else {
            errorToastMessage(response.data.message);
            resolve([]);
          }
          dispatch(loader(false));
        })
        .catch((error) => {
          console.error(error);
          dispatch(loader(false));
          reject(error);
        });
    });
  };
}

export const downloadExcelUploadReport = (tableData) => async (dispatch) => {
  dispatch(loader(true));
  const data = {
    data: tableData,
  };
  const URL = `${Config.url}gstR2a2bnew/downloaduploadReport`;

  try {
    const response = await axios({
      method: "post",
      url: URL,
      headers: { token: getLocalStorage("loginDetails") },
      responseType: "blob",
      data: data,
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "GSTR2a2b_DOWNLOAD_REPORT.xlsx");
    document.body.appendChild(link);
    link.click();

    link.remove();
    URL.revokeObjectURL(url);

    successToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_SUCCESS);
  } catch (error) {
    errorToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_ERROR);
  } finally {
    dispatch(loader(false));
  }
};

export const onCallUpload = (data) => {
  return (dispatch) => {
    dispatch(loader(true));

    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/saveRecoUploadExcel`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          if (response.data.error === 0) {
            successToastMessage(response.data.message);
            resolve(true);
          } else {
            errorToastMessage(response.data.message);
            resolve(false);
          }
          dispatch(loader(false));
        })
        .catch((error) => {
          console.log(error);
          dispatch(loader(false));
          reject(true);
        });
    });
  };
};

const getFileName = (status) => {
  switch (status) {
    case "P":
      return "PassedRecords.xlsx";
    case "F":
      return "FailedRecords.xlsx";
    case "T":
      return "TotalRecords.xlsx";
    default:
      return "Report.xlsx";
  }
};

export const downloadReport = (row, status) => async (dispatch) => {
  dispatch(loader(true));
  const data = {
    upload_batch_Id: row.UPLOAD_BATCH_ID ?? '',
    downloadType: status,
    reco_type:row.RECO_TYPE ?? ''
  };
  const URL = `${Config.url}gstR2a2bnew/getRecoUploadSummary`;

  try {
    const response = await axios({
      method: "post",
      url: URL,
      headers: { token: getLocalStorage("loginDetails") },
      responseType: "blob",
      data: data,
      validateStatus: () => true, // allow handling all status codes manually
    });

    // Only allow download if status code is 200
    if (response.status === 200 && response.data) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", getFileName(status));
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      successToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_SUCCESS);
    } else {
      errorToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_ERROR);
    }
  } catch (error) {
    errorToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_ERROR);
  } finally {
    dispatch(loader(false));
  }
};

export const downloadExcelSupplierWise =
  (tableData, type) => async (dispatch) => {
    dispatch(loader(true));
    const data = {
      tableData: tableData,
    };
    const URL =
      type === "IssueWise"
        ? `${Config.url}gstR2a2bnew/downloadIssueWiseRecoData`
        : `${Config.url}gstR2a2bnew/downloadSupplierWiseRecoData`;

    try {
      const response = await axios({
        method: "post",
        url: URL,
        headers: { token: getLocalStorage("loginDetails") },
        responseType: "blob",
        data: data,
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const fileName =
        type === "IssueWise"
          ? "GSTR2a2b_Issue_Wise.xlsx"
          : "GSTR2a2b_Supplier_Wise_.xlsx";
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      link.remove();

      successToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_SUCCESS);
    } catch (error) {
      console.error("Error downloading Excel:", error);
      errorToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_ERROR);
    } finally {
      dispatch(loader(false));
    }
  };

export const downloadExcelIssueWise = (tableData) => async (dispatch) => {
  dispatch(loader(true));
  const data = {
    data: tableData,
  };
  const URL = `${Config.url}gstR2a2bnew/downloadissuewise`;

  try {
    const response = await axios({
      method: "post",
      url: URL,
      headers: { token: getLocalStorage("loginDetails") },
      responseType: "blob",
      data: data,
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "GSTR2a2b_ISSUE_WISE.xlsx");
    document.body.appendChild(link);
    link.click();

    link.remove();
    URL.revokeObjectURL(url);

    successToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_SUCCESS);
  } catch (error) {
    errorToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_ERROR);
  } finally {
    dispatch(loader(false));
  }
};
const getExcelName = (type) => {
  const fileNames = {
    1: "Matched.xlsx",
    2: "Probable_Match.xlsx",
    3: "Mismatch.xlsx",
    4: "Not_In_PR.xlsx",
    5: "Not_In_Gstn.xlsx",
    6: "Rejected.xlsx",
  };

  return fileNames[type] || "Report.xlsx";
};
export const downloadExcelDocView =
  (
    selectedGstin,
    selection,
    recoSelection,
    selectedYear,
    dateRange,
    activeTabReco,
    activeTabViewReco,
    activeTabDocView,
    runRecoAcrossFY
  ) =>
  async (dispatch) => {
    dispatch(loader(true));
    const data = {
      gstin: selectedGstin,
      reco_type: recoSelection,
      fyYear: selectedYear,
      recoBase: selection,
      dateRange: dateRange,
      ret_period: getRetPeriodFromDateRange(selection, dateRange, selectedYear),
      activeTabReco,
      activeTabViewReco,
      activeTabDocView,
      p_across_fy: runRecoAcrossFY,
      limit:500000,pageNo:1
    };
    const URL = `${Config.url}gstR2a2bnew/downloadDocumentWiseRecoData`;

    try {
      const response = await axios({
        method: "post",
        url: URL,
        headers: { token: getLocalStorage("loginDetails") },
        responseType: "blob",
        data: data,
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const filename = getExcelName(activeTabDocView);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      link.remove();

      successToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_SUCCESS);
    } catch (error) {
      errorToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_ERROR);
    } finally {
      dispatch(loader(false));
    }
  };

export function reset3bAction(selected,selectedRow) {
  return async (dispatch) => {
    let reco_type = "";
  if (Array.isArray(selectedRow) && selectedRow.length > 0 && selectedRow[0].RECO_TYPE) {
    reco_type = selectedRow[0].RECO_TYPE;
  }
    const data = {
      txnArray: selected,
      reco_type: reco_type,
    };
    console.log("data in reset3bAction", data);
    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/reset3bStatus`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      if (response.data.error === 0) {
        successToastMessage(response.data.message);
        return response.data.data;
      } else {
        errorToastMessage(response.data.message);
        return [];
      }
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      dispatch(loader(false));
    }
  };
}
export function mark3bStatus(selected, selection, selectedRowMatched) {
  return async (dispatch) => {
      // Extract reco_type from selectedRowPR or selectedRowGSTN as a single string
  let reco_type = "";
  if (Array.isArray(selectedRowMatched) && selectedRowMatched.length > 0 && selectedRowMatched[0].RECO_TYPE) {
    reco_type = selectedRowMatched[0].RECO_TYPE;
  }
    
    // Format date to "Month-YYYY" format
    let formattedMonth = selection;
    if (selection && moment(selection).isValid()) {
      formattedMonth = moment(selection).format("MMMM-YYYY");
    }
    
    const data = {
      txnArray: selected,
      month: formattedMonth,
      reco_type: reco_type,
    };
    console.log("data in mark3bStatus:", data);
    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/mark3bStatus`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      if (response.data.error === 0) {
        successToastMessage(response.data.message);
        return response.data.data;
      } else {
        errorToastMessage(response.data.message);
        return [];
      }
    } catch (error) {
      console.error(error);
      // throw error;
    } finally {
      dispatch(loader(false));
    }
  };
}
export function getReset(selected, selectedRow) {
  return (dispatch) => {
    const reco_type_arr = [...new Set(selectedRow.map((x) => x.RECO_TYPE))];
    const reco_type = reco_type_arr[0] ?? "";
    const data = {
      txnArray: selected,
      full_row: selectedRow,
      reco_type: reco_type,
    };
    console.log("data in getReset:", data);
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/resetSubCategoryAction`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error === 0) {
            successToastMessage(response.data.message);
            resolve(response.data.data);
          } else {
            errorToastMessage(response.data.message);
            resolve([]);
          }
          dispatch(loader(false));
        })
        .catch((error) => {
          console.error(error);
          dispatch(loader(false));
          reject(error);
        });
    });
  };
}

export function getAcceptPrGstn(selected, action, selectedRow) {
  return async (dispatch) => {
    // Get unique reco types and pick the first one as string
    const reco_type_arr = [...new Set(selectedRow.map((x) => x.RECO_TYPE))];
    const reco_type = reco_type_arr[0] ?? "";

    const data = {
      txnId: selected,
      action: action,
      reco_type: reco_type,
    };

    dispatch(loader(true));
    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/acceptAndRejectPrAction`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      if (response.data.error === 0) {
        successToastMessage('Data Accepted successfully');
        return response.data.data;
      } else {
        errorToastMessage(response.data.message);
        return [];
      }
    } catch (error) {
      console.error("error in getAcceptPrGstn:", error);
      errorToastMessage("Something went wrong.");
      return [];
    } finally {
      dispatch(loader(false));
    }
  };
}

export function getPending(selected, action, selectedRow) {
  return (dispatch) => {
    const reco_type_arr = [...new Set(selectedRow.map((x) => x.RECO_TYPE))];
    const reco_type = reco_type_arr[0] ?? "";
    const data = {
      txnArray: selected,
      action: action,
      reco_type: reco_type,
    };
    console.log("data in getPending", data);
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/updatePendingAndResetAction`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error === 0) {
            successToastMessage(response.data.message);
            resolve(response.data.data);
          } else {
            errorToastMessage(response.data.message);
            resolve([]);
          }
          dispatch(loader(false));
        })
        .catch((error) => {
          console.error(error);
          dispatch(loader(false));
          reject(error);
        });
    });
  };
}

export function getDeLink(selected, selectedRow) {
  return async (dispatch) => {
    // Extract unique values inline
    const gstin = [...new Set(selectedRow.map((x) => x.GSTIN))];
    const ret_period = [...new Set(selectedRow.map((x) => x.RET_PERIOD))];
    const reco_type = [...new Set(selectedRow.map((x) => x.RECO_TYPE))];
    const reco_type_str = reco_type[0];
    const data = {
      ptxnArr: selected,
      gstin,
      ret_period,
      reco_type: reco_type_str,
    };

    console.log("Data in getDeLink:", data);

    dispatch(loader(true));

    try {
      const response = await axios.post(
        `${Config.url}gstR2a2bnew/delink`,
        data,
        {
          headers: {
            token: getLocalStorage("loginDetails"),
          },
        }
      );

      if (response.data.error === 0) {
        successToastMessage(response.data.message);
        return response.data.data;
      } else {
        errorToastMessage(response.data.message);
        return [];
      }
    } catch (error) {
      console.error("getDeLink API error:", error);
      errorToastMessage("Something went wrong while de-linking.");
      return [];
    } finally {
      dispatch(loader(false));
    }
  };
}

export function getReject(selected, action, selectedRow) {
  return async (dispatch) => {
    const reco_type_arr = [...new Set(selectedRow.map((x) => x.RECO_TYPE))];
    const reco_type = reco_type_arr[0] ?? "";
    const data = {
      txnArray: selected,
      action: action,
      reco_type: reco_type,
    };
    console.log("data in getReject", data);
    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/updatePendingAndResetAction`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });
      if (response.data.error === 0) {
        successToastMessage('Data Rejected successfully');
        return response.data.data;
      } else {
        errorToastMessage(response.data.message);
        return [];
      }
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      dispatch(loader(false));
    }
  };
}

export const getRecoHistory = (search, pageNo) => {
  return async (dispatch) => {
    dispatch(loader(true));

    const data = {
      str: search ? search : "",
      pageNo: pageNo ? pageNo : 1,
      limit: 10,
    };

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/getRecoHistory`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });
      const pageLimit = 10;
      if (response.data.error === 0) {
        const pages =
          response.data.data && response.data.data.length
            ? response.data?.data?.[0]?.FULL_COUNT
            : 10;
        dispatch(setTotalPagesRecoHistory(Math.ceil(pages / pageLimit)));
        dispatch(setRecoHistoryTableData(response.data.data));
        return response.data.data;
      } else {
        errorToastMessage(response.data.message);
        dispatch(setRecoHistoryTableData([]));
        return [];
      }
    } catch (error) {
      console.error(error);
      dispatch(setRecoHistoryTableData([]));
    } finally {
      dispatch(loader(false));
    }
  };
};

export const getPipelineStatus = (UUID) => {
  return async (dispatch) => {
    // dispatch(loader(true));

    const data = {
      batchId: UUID,
    };
    // console.log('getPipelineStatus called with fileIds:', fileIds);
    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/getRecoPipeStatus`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      if (response.data.error === 0) {
        return response.data.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error(error);
    } finally {
      // dispatch(loader(false));
    }
  };
};

function transformCategoryData(data) {
  const result = [];
  const categoryData = data[0]?.SP_GET_ISSUE_WISE_CATEGORY_VIEW;

  if (!categoryData) return result;

  // Add "Total" as a separate category
  result.push({
    category: "Total",
    ...categoryData.Total,
  });

  // Add each individual category from the data array
  categoryData.data.forEach((item) => {
    const transformedItem = {
      category: item.category,
      document_count_gstn: item.document_count_gstn,
      document_count_pr: item.document_count_pr,
      total_gst_amt_gstn: item.total_gst_amt_gstn,
      total_gst_amt_pr: item.total_gst_amt_pr,
      total_txval_gstn: item.total_txval_gstn,
      total_txval_pr: item.total_txval_pr,
    };

    if (Array.isArray(item.subcategory)) {
      transformedItem.subcategory = item.subcategory;
    }

    result.push(transformedItem);
  });

  return result;
}

// clear inside data array frorm fields

function cleanSubcategories(dataArray) {
  return dataArray.map((item) => {
    // Keep Total as-is
    if (item.category === "Total") return item;

    // Keep subcategory for categories that should expand in the issue-wise table
    if (
      item.category === "Matched" ||
      item.category === "Mismatched" ||
      item.category === "Probable Match"
    ) {
      return item;
    }

    // For other categories, empty the subcategory array if it exists
    const newItem = { ...item };
    if ("subcategory" in newItem) {
      newItem.subcategory = [];
    }
    return newItem;
  });
}

export function getRecoTablesData(
  selectedGstin,
  selection,
  recoSelection,
  selectedYear,
  dateRange,
  activeTabReco,
  activeTabViewReco,
  activeTabDocView,
  pageNo,
  rgstinTaxpayerFilter,
  sgstinTaxpayerFilter,
  inumFilter,
  monthFilter,
  month3bFilter,
  baseDataFilter,
  availedFilter,
  search,
  isToast,
  filterGstin,
  docDateFilter,
  runRecoAcrossFY
) {
  return (dispatch) => {
    const normalizedDocDateFilter =
      Array.isArray(docDateFilter) &&
      docDateFilter[0]?.startDate &&
      docDateFilter[0]?.endDate
        ? docDateFilter
        : null;

    const data = {
      gstin:
        filterGstin && filterGstin?.length > 0 ? filterGstin : selectedGstin,
      reco_type: recoSelection,
      fyYear: selectedYear,
      recoBase: selection,
      dateRange: normalizedDocDateFilter,
      ret_period: getRetPeriodFromDateRange(selection, dateRange, selectedYear),
      activeTabReco,
      activeTabViewReco,
      activeTabDocView,
      pageNo: pageNo,
      search_str: search,
      r_gstin_filter: rgstinTaxpayerFilter,
      supplierGstin: sgstinTaxpayerFilter,
      documentNumber: inumFilter,
      month_filter: monthFilter,
      p_3b_month: month3bFilter,
      baseData: baseDataFilter,
      p_3b_availed: availedFilter,
      p_across_fy: runRecoAcrossFY,
      limit: 10,
    };
    console.log("Data in handleSubmit::", data);
    let url = `${Config.url}gstR2a2bnew/getRecoData`;

    console.log("activeTabReco::", activeTabReco);
    console.log("activeTabViewReco::", activeTabViewReco);
    console.log("activeTabDocView::", activeTabDocView);
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: url,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error === 0) {
            if (isToast) successToastMessage(response.data.message);
            if (activeTabReco === "1") {
              dispatch(setRecoHistoryTableData(response.data.data));
            } else if (activeTabReco === "2" && activeTabViewReco === "1") {
              const tableData = transformCategoryData(response.data.data);
              const newData = cleanSubcategories(tableData);
              dispatch(setIssueWiseTableData(newData));
            } else if (activeTabReco === "2" && activeTabViewReco === "2") {
              // const docViewData = addUniqueKeysDocView(response.data.data)
              const tabDispatchMap = {
                1: setTotalPageMatched,
                3: setTotalPageMismatch,
                2: setTotalPageProbable,
                5: setTotalPageNotInGstn,
                4: setTotalPageNotInPr,
                6: setTotalPageRejected,
              };
              const pages =
                response.data.data && response.data.data.length
                  ? response.data?.data?.[0]?.TOTAL_RECORDS
                  : 10;

              const action = tabDispatchMap[activeTabDocView];
              console.log("action::", action);
              if (action) {
                dispatch(action(Math.ceil(pages / 10)));
              }
              dispatch(setDocViewTableData(response.data.data));
            } else if (activeTabReco === "2" && activeTabViewReco === "3") {
              dispatch(setSupplierWiseTableData(response.data.data));
            }
            // else if (activeTabReco === "2" && activeTabViewReco === "4") {
            //   dispatch(setDownloadReportTableData(response.data.data));
            // } else if (activeTabReco === "2" && activeTabViewReco === "5") {
            //   const pages =
            //     response.data.data && response.data.data.length
            //       ? response.data?.data?.[0]?.TOTAL_RECORDS
            //       : 10;
            //   dispatch(setTotalPagesUploadReport(Math.ceil(pages / 10)));

            //   dispatch(setUploadReportTableData(response.data.data));
            // }
            else if (activeTabReco === "3") {
              dispatch(setDocDateTableData(response.data.data));
            }
            resolve(response.data.data);
          } else {
           if (isToast) errorToastMessage(response.data.message);
            if (activeTabReco === "1") {
              dispatch(setRecoHistoryTableData([]));
            }
            if (activeTabReco === "2" && activeTabViewReco === "1") {
              dispatch(setIssueWiseTableData([]));
            } else if (activeTabReco === "2" && activeTabViewReco === "2") {
              dispatch(setViewRecoTableData([]));
              dispatch(setDocViewTableData([]));
            } else if (activeTabReco === "2" && activeTabViewReco === "3") {
              dispatch(setSupplierWiseTableData([]));
            } else if (activeTabReco === "2" && activeTabViewReco === "4") {
              dispatch(setDownloadReportTableData([]));
            } else if (activeTabReco === "2" && activeTabViewReco === "5") {
              dispatch(setUploadReportTableData([]));
            } else if (activeTabReco === "3") {
              dispatch(setDocDateTableData([]));
            }
            resolve([]);
          }
          dispatch(loader(false));
        })
        .catch((error) => {
          console.error(error);
          dispatch(loader(false));
          reject(error);
        });
    });
  };
}

export function getRecoFilterList(
  selectedGstin,
  selection,
  recoSelection,
  selectedYear,
  dateRange,
  activeTabReco,
  activeTabViewReco,
  activeTabDocView
) {
  return async (dispatch) => {
    const data = {
      gstin: selectedGstin,
      reco_type: recoSelection,
      fyYear: selectedYear,
      recoBase: selection,
      dateRange: dateRange,
      ret_period: getRetPeriodFromDateRange(selection, dateRange, selectedYear),
      activeTabReco,
      activeTabViewReco,
      activeTabDocView,
    };
    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/getRecoFilters`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });
      if (response.data.error === 0) {
        // successToastMessage(response.data.message);
        return response.data.data;
      } else {
        errorToastMessage(response.data.message);
        return [];
      }
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      dispatch(loader(false));
    }
  };
}

export function getSideWisedata(
  selectedGstin,
  selection,
  recoSelection,
  selectedYear,
  dateRange,
  activeTabReco,
  activeTabViewReco,
  activeTabDocView,
  pageNo
) {
  return async (dispatch) => {
    const data = {
      gstin: selectedGstin,
      reco_type: recoSelection,
      fyYear: selectedYear,
      recoBase: selection,
      dateRange: dateRange,
      ret_period: getRetPeriodFromDateRange(selection, dateRange, selectedYear),
      activeTabReco,
      activeTabViewReco,
      activeTabDocView,
      // pageNo: pageNo,
      // limit: 10,
    };
    const url = `${Config.url}gstR2a2bnew/getSidewisedata`;
    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: url,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      if (response.data.error === 0) {
        // successToastMessage(response.data.message);
        return response.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      dispatch(loader(false));
    }
  };
}

export function getUploadReportData(pageNo, search, isToast) {
  return async (dispatch) => {
    const payload = {
      pageNo: pageNo || 1,
      search: search || "",
      limit: 10,
    };

    const url = `${Config.url}gstR2a2bnew/getRecoUploadHistory`;

    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: url,
        data: payload,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      if (response.data.error === 0) {
        if (isToast) successToastMessage(response.data.message);

        const totalRecords =
          response.data.data?.length > 0
            ? response.data.data[0]?.FULL_COUNT
            : 10;
        const totalPages = Math.ceil(totalRecords / 10);

        dispatch(setTotalPagesUploadReport(totalPages));
        dispatch(setUploadReportTableData(response.data.data));

        return response.data.data;
      } else {
        console.log(
          "getUploadReportData API returned error:",
          response.data.message
        );
        if (isToast) errorToastMessage(response.data.message);
        dispatch(setTotalPagesUploadReport(1));
        dispatch(setUploadReportTableData([]));
        return [];
      }
    } catch (error) {
      console.error("❌ [getUploadReportData] API request failed:", error);

      errorToastMessage("Failed to fetch upload report data.");

      dispatch(setTotalPagesUploadReport(1));
      dispatch(setUploadReportTableData([]));
    } finally {
      dispatch(loader(false));
    }
  };
}

export function getDownloadReportData(
  selectedGstin,
  reco_type,
  recoSelection,
  selectedYear,
  dateRange,
  search,
  isToast
) {
  return async (dispatch) => {
    const payload = {
      search: search || "",
      gstin: selectedGstin,
      reco_type: reco_type || "",
      recoSelection: recoSelection || "",
      selectedYear: selectedYear || "",
      dateRange: dateRange || "",
      ret_period: getRetPeriodFromDateRange(recoSelection, dateRange, selectedYear),
    };

    const url = `${Config.url}gstR2a2bnew/getDownloadTabRecoHistory`;

    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: url,
        data: payload,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      if (response.data.error === 0) {
        if (isToast) successToastMessage(response.data.message);
        dispatch(setDownloadReportTableData(response.data.data));

        return response.data.data;
      } else {
        console.log(
          "getUploadReportData API returned error:",
          response.data.message
        );
        if (isToast) errorToastMessage(response.data.message);
        dispatch(setDownloadReportTableData([]));
        return [];
      }
    } catch (error) {
      console.error("[getUploadReportData] API request failed:", error);

      errorToastMessage("Failed to fetch upload report data.");
      dispatch(setDownloadReportTableData([]));
    } finally {
      dispatch(loader(false));
    }
  };
}

export const downloadReportSingle = (row) => async (dispatch) => {
  dispatch(loader(true));
  console.log('row in downloadRecoTabData::',row)
  const gstin = Array.isArray(row.GSTIN) ? row.GSTIN : [row.GSTIN];
  // Use PR_PERIOD if present, else GSTR_2A_2B_PERIOD
  const ret_period =
    row.PR_PERIOD !== undefined &&
    row.PR_PERIOD !== null &&
    row.PR_PERIOD !== ""
      ? row.PR_PERIOD
      : row.GSTR_2A_2B_PERIOD ?? "";

  // Use PR_FISCAL_YEAR if present, else GSTR_2A_2B_FISCAL_YEAR
  const fyYear =
    row.PR_FISCAL_YEAR !== undefined &&
    row.PR_FISCAL_YEAR !== null &&
    row.PR_FISCAL_YEAR !== ""
      ? row.PR_FISCAL_YEAR
      : row.GSTR_2A_2B_FISCAL_YEAR ?? "";

  const reco_type = row.RECO_TYPE ?? "";
  const ra_fy = row.P_ACROSS_FY ?? '';
  const tolerance = row.IGNOREIVAL ?? '';
  const tolerance_taxes = row.IGNOREIVALTVAL ?? '';
  const fuzzy_logic = row.FUZZY_LOGIC ?? '';
  const incld_unavail_crdt = row.NONAVAILEDITC ?? '';
  const entity_name = row.ENTITY_NAME ?? '';
  const batchid = row.UUID ?? "";
  const data = {
    gstin,
    batchid,
    ret_period,
    reco_type,
    fyYear,
    ra_fy,
    tolerance,
    fuzzy_logic,
    incld_unavail_crdt,
    entity_name,
    tolerance_taxes
  
  };
  const URL = `${Config.url}gstR2a2bnew/downloadRecoTabData`;

  try {
    const response = await axios({
      method: "post",
      url: URL,
      headers: { token: getLocalStorage("loginDetails") },
      responseType: "blob",
      data: data,
      validateStatus: () => true, // allow handling all status codes manually
    });

    if (response.status === 200 && response.data) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const filename = "Download_Report.xlsx";
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      successToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_SUCCESS);
    } else {
      errorToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_ERROR);
    }
  } catch (error) {
    errorToastMessage(GSTR2A2BNEW_MSGS.EXCEL_DOWNLOAD_ERROR);
  } finally {
    dispatch(loader(false));
  }
};

export const updateComments = (row, content) => async (dispatch) => {
  dispatch(loader(true));
  const data = {
    comments: content ?? "",
    txn_id: row?.TXN_ID ?? "",
    reco_type: row?.RECO_TYPE ?? "",
  };
  try {
    const response = await axios({
      method: "post",
      url: `${Config.url}gstR2a2bnew/updateComments`,
      headers: { token: getLocalStorage("loginDetails") },
      data: data,
    });
    if (response.data.error === 0) {
      successToastMessage(response.data.message);
      return response.data.data;
    } else {
      errorToastMessage(response.data.message);
      return [];
    }
  } catch (error) {
    errorToastMessage("Failed to update comments.");
  } finally {
    dispatch(loader(false));
  }
};

export const updateAction = (type, selectedRowPR, selectedRowGSTN) => async (dispatch) => {
  dispatch(loader(true))
  const action = type ?? '';

  // Extract reco_type from selectedRowPR or selectedRowGSTN as a single string
  let reco_type = "";
  if (Array.isArray(selectedRowPR) && selectedRowPR.length > 0 && selectedRowPR[0].RECO_TYPE) {
    reco_type = selectedRowPR[0].RECO_TYPE;
  } else if (Array.isArray(selectedRowGSTN) && selectedRowGSTN.length > 0 && selectedRowGSTN[0].RECO_TYPE) {
    reco_type = selectedRowGSTN[0].RECO_TYPE;
  }

  // Extract and combine unique GSTINs, ret_periods, and reco_types from both arrays
  const gstinPR = Array.isArray(selectedRowPR) ? selectedRowPR.map(row => row.GSTIN).filter(Boolean) : [];
  const gstinGSTN = Array.isArray(selectedRowGSTN) ? selectedRowGSTN.map(row => row.GSTIN).filter(Boolean) : [];
  const gstin = Array.from(new Set([...gstinPR, ...gstinGSTN]));

  const retPeriodPR = Array.isArray(selectedRowPR) ? selectedRowPR.map(row => row.RET_PERIOD).filter(Boolean) : [];
  const retPeriodGSTN = Array.isArray(selectedRowGSTN) ? selectedRowGSTN.map(row => row.RET_PERIOD).filter(Boolean) : [];
  const ret_period = Array.from(new Set([...retPeriodPR, ...retPeriodGSTN]));

// Extract txn_id from selectedRowPR
  const txn_id_pr = Array.isArray(selectedRowPR) ? selectedRowPR.map(row => row.TXN_ID).filter(Boolean) : [];
  const txn_id_gstn = Array.isArray(selectedRowGSTN) ? selectedRowGSTN.map(row => row.TXN_ID).filter(Boolean) : [];

  const data = {
    action,
    gstin,
    ret_period,
    reco_type,
    txnId1 : txn_id_pr,
    txnId2 : txn_id_gstn
  };
  try {
    // const response = await axios.post(
    //   `${Config.url}gstR2a2bnew/updateSideWiseComponent`,
    //   data
    // );
   const response= await axios({
      method: "post",
      url: `${Config.url}gstR2a2bnew/updateSideWiseComponent`,
      headers: { token: getLocalStorage("loginDetails") },
      data: data,
    });
    if (response.data.error === 0) {
      successToastMessage(response.data.message);
      return response.data.data;
    } else {
      errorToastMessage(response.data.message);
      return [];
    }
  } catch (error) {
    errorToastMessage("Failed to update comments.");
  } finally {
    dispatch(loader(false));
  }
};
